import * as types from '../../constants/ActionTypes.js'

const initModalState = {
    splitReceiptModal: {
        show: false,
        receiptlinesleft: [],
        receiptlinesright: [],
        confirm: null,
        dispatch: null,
        confirmbuttontext: null
    },
    searchModal: {
        show: false,
        searchlist: [],
        keyword: null
    },
    receiptModal: {
        show: false
    },
    paymentModal: {
        show: false,
        cardinserted: false
    },
    weighModal: {
        show: false,
        weight: -1,
        articleId: 0,
        message: '',
        deviceId: 0
    },
    datePickerModal: {
        show: false
    },
    customerExistsModal: {
        show: false,
        listvalues: []
    },
    customerBaseModal: {
        show: false,
        listvalues: []
    },
    configurationListModal: {
        show: false,
        listvalues: []
    },
    managerLoginModal: {
        show: false,
        listvalues: []
    },
    orderListModal: {
        show: false,
        listvalues: []
    },
    orderConfirmationModal: {
        show: false,
        objectitemnumber: '',
        receiptlines: []
    },
    articleBaseModal: {
        show: false,
        listvalues: []
    },
    ticketBaseModal: {
        show: false,
    },
    selectPagerModal: {
        show: false,
    },
    changeModal: {
        show: false,
        value: 0
    },
    inputModal: {
        show: false,
        message: '',
        placeholder: '',
        value: ''
    },
    createCustomerModal: {
        show: false,
        labels: [],
        customerId: 0
    },
    createTicketModal: {
        show: false,
        ticket: null,
        ticketusages: []
    },
    invoiceModal: {
        show: false,
        invoiceType: 100,
        receipts: []
    },
    invoiceInfoModal: {
        show: false,
        isCredit: false,
        callback: null,
        callbackparams: [],
        dispatch: null
    },
    reservationModal: {
        show: false,
        reservation: null,
        paymentParam: null
    },
    addBalanceToTicketModal: {
        show: false,
        paymentId: 0,
        amount: 0.0
    },
    cashRegistrationModal: {
        show: false,
        isCashIn: false,
        description: '',
        amount: ''
    }
}

export const modalReducer = function init(state = initModalState, action) {
    switch (action.type) {
        case types.SET_SPLIT_RECEIPT_MODAL:
            return {
                ...state,
                splitReceiptModal: {
                    show: action.show,
                    receiptlinesleft: action.receiptlinesleft,
                    receiptlinesright: action.receiptlinesright,
                    confirm: action.confirm,
                    dispatch: action.dispatch,
                    confirmbuttontext: action.confirmbuttontext
                }
            };
        case types.SPLIT_RECEIPT_MODAL_RECEIPTLINE_SWITCH:
            return {
                ...state,
                splitReceiptModal: {
                    show: true,
                    receiptlinesleft: action.receiptlinesleft,
                    receiptlinesright: action.receiptlinesright,
                    confirm: state.splitReceiptModal.confirm,
                    dispatch: state.splitReceiptModal.dispatch,
                    confirmbuttontext: state.splitReceiptModal.confirmbuttontext
                }
            };
        case types.SET_SEARCH_MODAL:
            return {
                ...state,
                searchModal: {
                    show: action.show,
                    searchlist: action.searchlist,
                    keyword: action.keyword
                }
            };
        case types.SET_RECEIPT_MODAL:
            return {
                ...state,
                receiptModal: {
                    show: action.show
                }
            };
        case types.SET_PAYMENT_MODAL:
            return {
                ...state,
                paymentModal: {
                    show: action.show,
                    cardinserted: !action.show ? false : state.paymentModal.cardinserted
                }
            };
        case types.SET_DATEPICKER_MODAL:
            return {
                ...state,
                datePickerModal: {
                    show: action.show,
                    callback: action.callback,
                    callbackparams: action.callbackparams,
                    dispatch: action.dispatch
                }
            };
        case types.SET_CUSTOMEREXISTS_MODAL:
            return {
                ...state,
                customerExistsModal: {
                    listvalues: action.listvalues,
                    show: action.show,
                    callback: action.callback,
                    callbackparams: action.callbackparams,
                    dispatch: action.dispatch
                }
            };
        case types.SET_CUSTOMERBASE_MODAL:
            return {
                ...state,
                customerBaseModal: {
                    listvalues: action.listvalues,
                    show: action.show,
                    callback: action.callback,
                    callbackparams: action.callbackparams,
                    dispatch: action.dispatch
                }
            };
        case types.SET_CREATE_CUSTOMER_MODAL:
            return {
                ...state,
                createCustomerModal: {
                    show: action.show,
                    callback: action.callback,
                    callbackparams: action.callbackparams,
                    dispatch: action.dispatch,
                    labels: action.labels,
                    customerId: action.customerId,
                }
            };
        case types.SET_CREATE_TICKET_MODAL:
            return {
                ...state,
                createTicketModal: {
                    show: action.show,
                    callback: action.callback,
                    callbackparams: action.callbackparams,
                    dispatch: action.dispatch,
                    ticket: action.ticket,
                    ticketusages: action.ticketusages
                }
            };
        case types.SET_TICKETBASE_MODAL:
            return {
                ...state,
                ticketBaseModal: {
                    show: action.show,
                    callback: action.callback,
                    callbackparams: action.callbackparams,
                    dispatch: action.dispatch
                }
            };
        case types.SET_ARTICLEBASE_MODAL:
            return {
                ...state,
                articleBaseModal: {
                    listvalues: action.listvalues,
                    show: action.show,
                    callback: action.callback,
                    callbackparams: action.callbackparams,
                    dispatch: action.dispatch
                }
            };
        case types.SET_CONFIGURATIONLIST_MODAL:
            return {
                ...state,
                configurationListModal: {
                    listvalues: action.listvalues,
                    show: action.show,
                    callback: action.callback,
                    callbackparams: action.callbackparams,
                    dispatch: action.dispatch
                }
            };
        case types.SET_MANAGERLOGIN_MODAL:
            return {
                ...state,
                managerLoginModal: {
                    listvalues: action.listvalues,
                    show: action.show,
                    callback: action.callback,
                    callbackparams: action.callbackparams,
                    dispatch: action.dispatch
                }
            };
        case types.SET_ORDERLIST_MODAL:
            return {
                ...state,
                orderListModal: {
                    listvalues: action.listvalues,
                    show: action.show,
                    callback: action.callback,
                    callbackparams: action.callbackparams,
                    dispatch: action.dispatch
                }
            };
        case types.SET_SELECT_PAGER_MODAL:
            return {
                ...state,
                selectPagerModal: {
                    show: action.show,
                    callback: action.callback,
                    callbackparams: action.callbackparams,
                    dispatch: action.dispatch
                }
            };
        case types.SET_ORDER_CONFIRMATION_MODAL:
            return {
                ...state,
                orderConfirmationModal: {
                    show: action.show,
                    objectitemnumber: action.objectitemnumber,
                    receiptlines: action.receiptlines

                }
            };
        case types.SET_PAYMENT_MODAL_CARD_INSERTED:
            return {
                ...state,
                paymentModal: {
                    show: state.paymentModal.show,
                    cardinserted: action.cardinserted
                }
            };
        case types.SET_WEIGH_MODAL:
            return {
                ...state,
                weighModal: {
                    show: action.show,
                    weight: -1,
                    articleId: action.articleId,
                    message: 'Wachten op weegschaal',
                    deviceId: action.deviceId
                }
            };
        case types.SET_WEIGH_MODAL_WEIGHT:
            return {
                ...state,
                weighModal: {
                    show: state.weighModal.show,
                    articleId: state.weighModal.articleId,
                    weight: action.weight,
                    message: state.weighModal.message,
                    deviceId: state.weighModal.deviceId
                }
            };
        case types.SET_SCALE_STATUS:
            return {
                ...state,
                weighModal: {
                    show: state.weighModal.show,
                    articleId: state.weighModal.articleId,
                    weight: state.weighModal.weight,
                    message: action.message,
                    deviceId: state.weighModal.deviceId
                }
            };
        case types.SET_CHANGE_MODAL:
            return {
                ...state,
                changeModal: {
                    show: action.show,
                    amount: action.amount
                }
            };
        case types.SET_INPUT_MODAL:
            return {
                ...state,
                inputModal: {
                    show: action.show,
                    message: action.message,
                    placeholder: action.placeholder,
                    callback: action.callback,
                    callbackparams: action.callbackparams,
                    dispatch: action.dispatch
                }
            };
        case types.SET_INVOICE_MODAL:
            return {
                ...state,
                invoiceModal: {
                    show: action.show,
                    invoiceType: action.invoiceType,
                    receipts: action.receipts
                }
            };
        case types.SET_INVOICE_INFO_MODAL:
            return {
                ...state,
                invoiceInfoModal: {
                    show: action.show,
                    isCredit: action.isCredit,
                    callback: action.callback,
                    callbackparams: action.callbackparams,
                    dispatch: action.dispatch
                }
            };
        case types.SET_RESERVATION_MODAL:
            return {
                ...state,
                reservationModal: {
                    show: action.show,
                    reservation: action.reservation,
                    paymentParam: action.paymentParam
                }
            };
        case types.SET_ADD_BALANCE_TO_TICKET_MODAL:
            return {
                ...state,
                addBalanceToTicketModal: action.data.show ? { ...action.data } : { ...initModalState.addBalanceToTicketModal }
            };
        case types.SET_CASH_REGISTRATION_MODAL:
            return {
                ...state,
                cashRegistrationModal: {
                    show: action.show,
                    isCashIn: action.isCashIn,
                    description: action.description,
                    amount: action.amount
                }
            };
        case types.CLEAR_STATE:
            return initModalState;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// src/modal/reducers/modal.js